export const getPosizioniSelezionateFromPersonalizzazione = (
  configurazioneScelta: any,
  configurazioniPossibili: any
) => {
  if (!configurazioneScelta?.posizioni || !configurazioniPossibili?.tecniche) {
    return []
  }

  const personalizzazioniMap = new Map()

  configurazioniPossibili.tecniche.forEach((tecnica: any) => {
    tecnica.posizioni.forEach((posizione: any) => {
      posizione.numero_colori.forEach((numeroColore: any) => {
        numeroColore.personalizzazioni_objects.forEach((po: any) => {
          personalizzazioniMap.set(po.id, {
            tecnica,
            posizione,
            numeroColore,
            matchPersonalizzazioneObject: po,
          })
        })
      })
    })
  })

  return configurazioneScelta.posizioni
    .map((initialPosizione: any) => {
      const selectedId = initialPosizione.personalizzazione_id
      const foundData = personalizzazioniMap.get(selectedId)

      if (!foundData) return null

      const { tecnica, posizione, numeroColore, matchPersonalizzazioneObject } = foundData

      return {
        ...posizione,
        colori: numeroColore,
        pantoni_codici: initialPosizione?.pantoni_codici || [],
        numero_colori: posizione.numero_colori,
        altezza: matchPersonalizzazioneObject.dimensione_altezza,
        selectedAltezza:
          initialPosizione?.altezza ?? matchPersonalizzazioneObject.dimensione_altezza,
        larghezza: matchPersonalizzazioneObject.dimensione_larghezza,
        selectedLarghezza:
          initialPosizione?.larghezza ?? matchPersonalizzazioneObject.dimensione_larghezza,
        posizione: posizione.nome,
        tecnica: tecnica.nome,
        tecnicaData: tecnica,
        descrizione_posizione: initialPosizione.descrizione_posizione || '',
        logo_file: initialPosizione.logo_file_url,
        logo_file_id: initialPosizione.logo_file,
        logo_filename: initialPosizione.logo_filename,
        tracciatura_logo: initialPosizione.tracciatura_logo,
      }
    })
    .filter(Boolean)
}

export const getConfigurazioneProdottoInitialValues = (
  configurazioneScelta: any,
  configurazioniPossibili: any
) => {
  if (!configurazioneScelta) return undefined

  const posizioni = getPosizioniSelezionateFromPersonalizzazione(
    configurazioneScelta,
    configurazioniPossibili
  )

  return {
    tecnica:
      posizioni?.[0]?.tecnicaData ||
      configurazioneScelta?.posizioni?.[0]?.tecnica ||
      configurazioneScelta?.posizioni?.[0]?.personalizzazione?.tecnica ||
      null,
    posizioni,
    confezionamento: configurazioneScelta?.confezionamento_richiesto,
    nomeLavorazione: configurazioneScelta?.nome_lavorazione,
    nomeLavorazioneManuale: configurazioneScelta?.nome_lavorazione_manuale,
    nomeLavorazioneNoIncrementale: configurazioneScelta?.nome_lavorazione_no_incrementale,
  }
}
